import {
  ADD_AWARD_FAILURE,
  ADD_AWARD_REQUEST,
  ADD_AWARD_RESET,
  ADD_AWARD_SUCCESS,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const addAwardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_AWARD_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case ADD_AWARD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case ADD_AWARD_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.message,
        success: false,
      }

    case ADD_AWARD_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default addAwardReducer
